<app-schedule-dialog [dialogData]="dialogData" [titleText]="'data.MAINTENANCE.PERIODIC_SYNC' | translate"
                     [scheduleText]="'data.MAINTENANCE.SYNC' | translate" [scheduleNowText]="'data.MAINTENANCE.SYNC_ON' | translate"
                     (scheduleSubmitted)="submitSchedule($event)" (dialogClosed)="closeDialog()"></app-schedule-dialog>
